import $ from "jquery";

const SELECT_VALUE_ATTR = "data-select-value-el";

const DEFAULT_CONFIG = {
    width: "100%",
    templateResult: formatResult,
    language: {
        noResults: () => "Geen resultaat gevonden",
    },
};

/**
 * Select2
 */
$(".js-select2")
    .not("[data-lazy-select2]")
    .each(function () {
        const $el = $(this);
        const parentSelector = $el.attr("data-dropdown-parent");
        const config = { ...DEFAULT_CONFIG };
        if (parentSelector) {
            const $parent = $el.closest(parentSelector);
            if ($parent.length) {
                config.dropdownParent = $parent;
            }
        }

        // Losstaand paneel in plaats van een pane die aan de pill vastzit — zie
        // `.select2-dropdown.v_panel` in _select2.scss.
        if ($el.is("[data-dropdown-panel]")) {
            config.dropdownCssClass = "v_panel";
        }

        $el.select2(config);
    });

// Direct fix for Android virtual keyboard blur issue
$(document).on("focus", ".select2-search__field", function () {
    const $field = $(this);

    // Add a blur handler that prevents keyboard-related blur on mobile
    $field.off("blur.mobile-fix").on("blur.mobile-fix", function (e) {
        // If blur has no relatedTarget, it's likely the virtual keyboard
        if (
            e.relatedTarget === null &&
            /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
        ) {
            e.preventDefault();
            e.stopImmediatePropagation();

            // Re-focus after a tiny delay to maintain the dropdown
            setTimeout(() => {
                if (
                    $field.is(":visible") &&
                    $field.closest(".select2-container--open").length > 0
                ) {
                    $field[0].focus();
                }
            }, 10);

            return false;
        }
    });
});

// select2 opens below unless there is no room, but it remembers the direction: the
// `select2-dropdown--above` class stays on the reused dropdown after closing, and the next open
// keeps it above as long as there is room there. In the sticky bar that meant: opened once while
// pinned to the bottom of the viewport, it kept opening upwards after scrolling back up. Clearing
// the direction before every open makes each open start from "below" again.
$(document).on("select2:opening", (e) => {
    $(e.target)
        .data("select2")
        ?.dropdown?.$dropdown?.removeClass(
            "select2-dropdown--above select2-dropdown--below",
        );
});

$(document).on("select2:open", (e) => {
    // Prevent Foundation touch/dropdown interference
    const $select2Container = $(e.target).next(".select2-container");

    // Temporarily disable Foundation touch events on select2 elements
    $select2Container
        .find(".select2-dropdown, .select2-search__field")
        .add($select2Container)
        .attr("data-touch-disabled", "true");

    // Apply custom search placeholder if defined on the original select
    const searchPlaceholder = $(e.target).attr("data-search-placeholder");
    if (searchPlaceholder) {
        document
            .querySelector(".select2-container--open .select2-search__field")
            ?.setAttribute("placeholder", searchPlaceholder);
    }

    // Prevent Foundation dropdowns from closing when select2 opens. Alleen de vlag: de
    // Foundation-versie hier kent geen `_addGlobalListeners`, en die aanroep gooide een
    // ReferenceError die de rest van de open-handler (en dus de dropdown zelf) tegenhield.
    $(".dropdown-pane.is-open").each(function () {
        $(this).data("select2-temp-disable", true);
    });
});

$(document).on("select2:close", () => {
    // Clean up mobile blur fix handlers
    $(".select2-search__field").off("blur.mobile-fix");

    // Re-enable Foundation touch events
    $(
        ".select2-container, .select2-dropdown, .select2-search__field",
    ).removeAttr("data-touch-disabled");

    // Restore Foundation dropdown behavior
    $(".dropdown-pane").each(function () {
        const $dropdown = $(this);
        if ($dropdown.data("select2-temp-disable")) {
            $dropdown.removeData("select2-temp-disable");
        }
    });

    // Close any open Foundation dropdowns (but only if not temporarily disabled)
    try {
        $(".dropdown-pane.is-open").each(function () {
            if (!$(this).data("select2-temp-disable")) {
                $(this).foundation("close");
            }
        });
    } catch (e) {
        // Ignore foundation error
    }
});

// Link a field to a select by attaching a data-select-value-el="<id>" to it
$(document).on("select2:select", ({ params, target }, customData) => {
    // Populate select in value field
    let text;

    // Allow for event to be sent using customData
    if (customData) {
        text = customData.text;
    } else {
        text = params.data.text;
    }

    const targetSelector = $(target).attr(SELECT_VALUE_ATTR);

    if (!targetSelector) {
        return;
    }

    const $valueEl = $(`#${targetSelector}`);

    if (!$valueEl) {
        return;
    }

    $valueEl.children("span").text(text);

    if (customData && customData.isPlaceholder) {
        $valueEl.removeClass("s_has-value");
    } else {
        $valueEl.addClass("s_has-value");
    }
});

function formatResult(option) {
    if ($(option.element).attr("data-hide-in-dropdown") === "true") {
        return null;
    }

    const level = parseInt($(option.element).attr("data-level"), 10);

    if (isNaN(level)) {
        return `${option.text}`;
    }

    // `data-level` op de regel zelf, zodat de stijl een niveau kan onderscheiden: de
    // bovenste laag (continenten in de blogfilter) staat vet, zie _select2.scss.
    return $(
        `<span class="select2-results__level" data-level="${level}" style="padding-left: ${0.75 * level}rem;">${option.text}</span>`,
    );
}

// Enable select2 dropdown lazily to be opened using a data attribute
$("[data-lazy-select2]")
    .not(".js-select2")
    .on("click", function () {
        const selectId = $(this).attr("data-lazy-select2");

        if (!selectId) {
            console.debug("No selectId was defined");
            return;
        }
        const openEl = $(`#${selectId}`);

        if (!openEl) {
            console.debug(`Could not find element with #${selectId}`);
            return;
        }

        // Skip init if it's already initialised
        if (!openEl.hasClass("select2-hidden-accessible")) {
            // Allow 1 tick for foundation dropdown to open dropdown before initialising. If we don't do this, the internal size calculations of select2
            // fail and the component will appear broken
            setTimeout(() => {
                openEl.select2(DEFAULT_CONFIG);
                openEl.select2("open");
            }, 0);
        } else {
            openEl.select2("open");
        }
    });
